/* eslint-disable max-len */
import cn from '@sindresorhus/class-names';
import Link from 'next/link';

import styles from './DirectionButton.module.scss';
import {Direction} from './types';
import getAriaLabel from './utils/getAriaLabel';

export type Props = {
  href: string;
  pageNumber: number;
  direction: Direction;
  className?: string;
};

const MessagesMap: Record<Direction, string> = {
  prev: 'Назад',
  next: 'Вперёд',
};

export const DirectionButton = ({
  href,
  pageNumber,
  direction,
  className,
}: Props) => (
  <Link
    href={href}
    className={cn(styles.container, styles[direction], className)}
    aria-label={getAriaLabel(pageNumber)}
    data-testid={direction}
  >
    <span className={styles.label}>{MessagesMap[direction]}</span>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={styles.icon}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.736 17.736a.9.9 0 0 0 0-1.272L10.273 12l4.463-4.464a.9.9 0 0 0-1.272-1.272l-5.1 5.1a.9.9 0 0 0 0 1.272l5.1 5.1a.9.9 0 0 0 1.272 0Z"
        fill="currentColor"
      />
    </svg>
  </Link>
);
